import { AnimatePresence } from 'framer-motion';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import DateRangeInput from '../../../../../date-range-input';
import { default as UIForm } from '../../../../../form';
import type { FilterDate } from '../../../../filters.types';
import { FilterDateRange } from '../../../../filters.types';
import useDateOptions from '../../hooks/use-date-options';
import getFormDefaultValue from './utils/get-form-default-values';
type FormData = {
  period: string;
  customDate: {
    from: Date;
    to: Date;
  };
};
type DateFormProps = {
  onSubmit: (period: FilterDate['selectedOptions']) => void;
  selectedOptions: FilterDate['selectedOptions'];
};
const DateForm = ({
  onSubmit,
  selectedOptions
}: DateFormProps) => {
  const options = useDateOptions();
  const methods = useForm<FormData>({
    defaultValues: getFormDefaultValue(selectedOptions)
  });
  const {
    control,
    handleSubmit,
    watch
  } = methods;
  const shouldShowDatePicker = watch('period') === FilterDateRange.Custom;
  const handleAfterSubmit = (formData: FormData) => {
    if (formData.period === FilterDateRange.Custom) {
      const newFrom = formData.customDate.from.toISOString();
      const newTo = formData.customDate.to.toISOString();
      onSubmit([newFrom, newTo]);
    } else {
      onSubmit([formData.period]);
    }
  };
  return <FormProvider {...methods}>
      <form className="grid gap-2" id="filter-form" onSubmit={handleSubmit(handleAfterSubmit)}>
        <UIForm.RadioGroup<FormData> name="period" options={options} className="flex flex-col gap-1" />
        <AnimatePresence>
          {shouldShowDatePicker && <Controller control={control} name="customDate" render={({
          field
        }) => <DateRangeInput side="bottom" align="start" initialStartDate={selectedOptions[0] ? new Date(selectedOptions[0]) : undefined} initialEndDate={selectedOptions[1] ? new Date(selectedOptions[1]) : undefined} onChange={(newDateStart, newDateEnd) => {
          field.onChange({
            from: newDateStart,
            to: newDateEnd
          });
        }} />} />}
        </AnimatePresence>
      </form>
    </FormProvider>;
};
export default DateForm;